/**
 * Created by mac on 9/25/20
 */

const Administrator = function () {
    this.adminEpisodes = new AdminEpisodes(this);
    this.adminLevels = new AdminLevels(this);

    if (Administrator.HasLocations()) {
        this.adminLocations = new AdminLocations();
    }

    this.adminDetails = new AdminDetails();

    this.simpleMethaDataProvider = new SimpleMethaDataProvider();
    this.log = new AdminLog();

    AdminLevelsChart.PrepareChart();

    if (AdminLanguage.IsAvailable()) {
        const adminLanguages = {};
        cleverapps.config.languages.forEach((language) => {
            adminLanguages[language] = new AdminLanguage(this, language, cleverapps.settings.language === language);
        });
        this.adminLanguages = adminLanguages;
    }
};

// games that browse locations in admin instead of episodes - an episode there is a location itself
Administrator.HasLocations = function () {
    return cleverapps.config.name === "wordsoup" || ["merge", "farm"].includes(cleverapps.config.type);
};

Administrator.guessLocation = function (level) {
    return Administrator.HasLocations() ? level.episodeNo : cleverapps.meta.getMainLocationId();
};

Administrator.prototype.openAdminSceneInNewTab = function () {
    let baseUrl;
    if (cleverapps.isLocalhost()) {
        baseUrl = window.location.href.split("#")[0];
    } else {
        baseUrl = window.location.origin;
    }
    const hashData = this.adminLocations ? AdminLocationsScene.getUrlHashData() : AdministratorScene.getUrlHashData();
    const urlHash = cleverapps.toUrlHash(hashData);
    connector.platform.openUrl(`${baseUrl}#${urlHash}`);
};

Administrator.prototype.updateGooglesheets = function (callback) {
    cleverapps.RestClient.get("/googlesheetcommands/update", {}, (result) => {
        callback(result.result);
        cleverapps.git.update();
    }, () => {
        callback("network error");
    }, 30000);
};

Administrator.prototype.setLanguage = function (language, callback) {
    const oldLanguage = cleverapps.settings.language;

    if (!this.adminLanguages || oldLanguage === language) {
        return;
    }

    cleverapps.focusManager.display({
        focus: "SetAdminLanguage",
        action: function (f) {
            this.adminLanguages[oldLanguage].unselect();
            this.adminLanguages[language].select();

            cleverapps.settings.setLanguage(language);

            this.adminEpisodes.reset(() => {
                f();
                callback && callback();
            });
        }.bind(this)
    });
};

Administrator.prototype.scrambleGoToSpreadsheets = function (episodeNo, levelNo) {
    const gid = {
        en: 0,
        ru: 1497319862,
        fr: 2132465089,
        it: 1727839938,
        de: 1616900791,
        es: 797836458,
        nl: 737846155,
        ja: 957913327,
        pl: 858975559,
        ko: 47567512,
        pt: 1954520613
    };

    const LEVELS_PER_EPISODE = 15;
    const row = episodeNo * LEVELS_PER_EPISODE + levelNo + 2;

    let url = "https://docs.google.com/spreadsheets/d/1e7g86FZWbm1oYqlg15ex8-TCyraMEoCVBEbyQKIr_XM/edit#gid=%{gid}&range=%{row}:%{row}";
    url = url.replace("%{gid}", gid[cleverapps.settings.language]);
    url = url.replaceAll("%{row}", row);

    connector.platform.openUrl(url);
};
